export default "__VITE_ASSET__CWJ5BR3S__"